export const DEPARTMENTS = [
  { code: "mutfak", name: "Mutfak" },
  { code: "kat", name: "Kat Hizmetleri" },
  { code: "onburo", name: "Ön Büro" },
  { code: "servis", name: "Servis" },
  { code: "teknik", name: "Teknik Servis" },
];

export const STATUS_OPTIONS = [
  { code: "CALISIYOR", label: "Çalışıyor", cls: "bg-emerald-500/20 text-emerald-300 border-emerald-500/40" },
  { code: "IZINLI", label: "İzinli", cls: "bg-cyan-500/20 text-cyan-300 border-cyan-500/40" },
  { code: "RAPORLU", label: "Raporlu", cls: "bg-amber-500/20 text-amber-300 border-amber-500/40" },
  { code: "HAFTA_TATILI", label: "Hafta Tatili", cls: "bg-sky-500/20 text-sky-300 border-sky-500/40" },
  { code: "UCRETSIZ_IZIN", label: "Ücretsiz İzin", cls: "bg-purple-500/20 text-purple-300 border-purple-500/40" },
  { code: "GELMEDI", label: "Gelmedi", cls: "bg-rose-500/20 text-rose-300 border-rose-500/40" },
];

export const deptName = (code) => DEPARTMENTS.find((d) => d.code === code)?.name || code;

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const inputCls =
  "w-full px-3 py-2 bg-slate-950/60 border border-cyan-500/30 rounded-lg text-sm text-white focus:border-cyan-400 focus:outline-none";
export const labelCls = "block text-[10px] font-mono text-cyan-300/70 uppercase tracking-widest mb-1";
